const { EURO_TEXT, ACCOUNT_INTERVENTION_OWNER } = require('constants/index');
const { CUSTOM_ACCOUNTS } = require("constants/expensesByCategories/filters");

const filterOwnVisibleEuroAccounts = (immAccounts, typeAccount = CUSTOM_ACCOUNTS) => {
    return immAccounts.get('byOrder').filter((accountId) => {
        const immAccount = immAccounts.getIn(['byId', accountId]);

        if (typeAccount === CUSTOM_ACCOUNTS) {
            return immAccount.getIn(['balance', 'currency']) === EURO_TEXT &&
            immAccount.getIn(['filters', 'valid']) &&
            immAccount.get('interventionType') === ACCOUNT_INTERVENTION_OWNER;
        } else {
            return immAccount.getIn(['balance', 'currency']) === EURO_TEXT &&
            immAccount.get('interventionType') === ACCOUNT_INTERVENTION_OWNER;
        }
    })
}

const getIbansAccounts = (immAccounts, typeAccount = CUSTOM_ACCOUNTS) => {
    return filterOwnVisibleEuroAccounts(immAccounts, typeAccount).map((accountId) => {
        const immAccount = immAccounts.getIn(['byId', accountId]);
        return immAccount.get('iban');
    }).toJS()
}

const getCustomAccounts = (immAccounts) => {
    return immAccounts.get('byId').reduce((acc,id) => id.getIn(['filters', 'valid'])? [...acc, id.get('iban')] : acc , []);
}

module.exports = {
    filterOwnVisibleEuroAccounts,
    getIbansAccounts,
    getCustomAccounts
};